/* ============================================================
   Kanadeal — Fiches produit : remplace le bloc de pills (.kd-meta-badges)
   par deux boutons « Caractéristiques » et « Description ». Au clic, ouvre
   l'accordéon correspondant (<details class="kd-accordion">) et scrolle
   jusqu'à lui. Idempotent + retry. Scope : page produit.
   ============================================================ */
(function () {
  var CHEV = '<svg class="kd-spec-btn__chev" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function findAccordion(root, kw) {
    var dets = root.querySelectorAll('details.kd-accordion');
    for (var i = 0; i < dets.length; i++) {
      var t = dets[i].querySelector('.kd-accordion__title');
      if (t && t.textContent.toLowerCase().indexOf(kw) !== -1) return dets[i];
    }
    return null;
  }

  function openAndScroll(det) {
    if (!det) return;
    det.open = true;
    requestAnimationFrame(function () {
      det.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function build() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return true;
    if (main.querySelector('.kd-spec-buttons')) return true;

    var carac = findAccordion(main, 'caract');
    var desc = findAccordion(main, 'description');
    if (!carac && !desc) return false; // accordeons pas encore rendus -> retry

    var badges = main.querySelector('.kd-meta-badges');

    var box = document.createElement('div');
    box.className = 'kd-spec-buttons';
    box.innerHTML =
      '<button type="button" class="kd-spec-btn kd-spec-btn--carac"><span class="kd-spec-btn__icon">🌿</span>Caractéristiques' + CHEV + '</button>' +
      '<button type="button" class="kd-spec-btn kd-spec-btn--desc"><span class="kd-spec-btn__icon">🔍</span>Description' + CHEV + '</button>';

    if (badges && badges.parentNode) {
      badges.parentNode.insertBefore(box, badges);
    } else {
      var media = main.querySelector('.product-information__media') || main.querySelector('.product-information__grid');
      if (!media) return false;
      media.insertBefore(box, media.firstChild);
    }

    box.children[0].addEventListener('click', function () { openAndScroll(carac); });
    box.children[1].addEventListener('click', function () { openAndScroll(desc); });
    return true;
  }

  function init() {
    if (build()) return;
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (build() || n > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
